import React, { Fragment } from 'react';
import {
    Input,
    Button,
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Contacts2.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';

const ContactsDemographics2 = (props) => {
    const {
        row,
        editCategoryCommentsArray,
        changeComment,
        handleEditSubmit,
        handleDelete,
        loading,
        isFormBlank,
        unsavedChanges,
        editID,
    } = props;

    if (!row) return null;

    return (
        <Row>
            <Col className="pl-5">
                <Row key={row.linkedID} className="notesFormTypeRow text-left">
                    {editCategoryCommentsArray.map(comment => {
                        if (comment.validation === 'list' && comment.multiline) {
                            return (
                                <Fragment key={comment.ID}>
                                    <Col md={4} key={comment.ID} className="mb-2">
                                        <Label>{comment.type}
                                            <Input
                                                type="select"
                                                name={comment.ID}
                                                multiple
                                                onChange={changeComment}
                                                value={Array.isArray(comment.value) ? comment.value : []}
                                            >
                                                <option value="0">Select {comment.type}</option>
                                                {comment.list != null && comment.list.map(item => (
                                                    <option key={item.ID} value={String(item.ID)}>
                                                        {item.longDescription}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Label>
                                    </Col>
                                </Fragment>
                            );
                        }

                        switch (comment.validation) {
                            case "list": {

                                return (
                                    <Col md={4} key={comment.ID} className="px-2">
                                        {typeof comment.list !== 'undefined' ? (
                                            <Label>{comment.type}
                                                <Input
                                                    type="select"
                                                    name={comment.ID}
                                                    value={isNaN(parseInt(comment.value) && parseInt(comment.value) > 0) ? 0 : parseInt(comment.value)}
                                                    onChange={changeComment}
                                                >
                                                    <option value="0">Select</option>
                                                    {comment.list != null && comment.list.map(item => (
                                                        <option key={item.ID} value={item.ID}>
                                                            {item.longDescription}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Label>
                                        ) : null}
                                    </Col>
                                );
                            }

                            case "date":
                                return (
                                    <Col md={4} key={comment.ID} className="px-2">
                                        <Label>{comment.type}
                                            <Input
                                                name={comment.ID}
                                                onChange={changeComment}
                                                value={comment.value}
                                                type="date"
                                            />
                                        </Label>
                                    </Col>
                                );

                            case "checkbox":
                                return (
                                    <Col md={4} key={comment.ID} className="mb-2 pl-4 mt-1">
                                        <Label>
                                            <Input
                                                name={comment.ID}
                                                onChange={changeComment}
                                                type="checkbox"
                                                checked={comment.value === 'true' || comment.value === true}
                                            />
                                            {comment.type}
                                        </Label>
                                    </Col>
                                );

                            case null:
                                return (
                                    <Col md={4} key={comment.ID} className='px-2'>
                                        <Label>{comment.type}
                                            <Input
                                                name={comment.ID}
                                                data-lpignore="true"
                                                onChange={changeComment}
                                                value={comment.value || ''}
                                                rows={comment.multiline ? 6 : 1}
                                                type={comment.multiline ? 'textarea' : 'text'}
                                            />
                                        </Label>
                                    </Col>
                                );

                            default:
                                return (
                                    <Col md={4} key={comment.ID} className='px-2'>
                                        <Label>
                                            {comment.type}{' '}
                                            {comment.validationHint != null ? (
                                                <span className="validationHint">({comment.validationHint})</span>
                                            ) : null}
                                            <Input
                                                className={comment.error ? "is-invalid" : ''}
                                                name={comment.ID}
                                                onChange={(e) => changeComment(e, comment.validation)}
                                                value={comment.value || ''}
                                                rows={comment.multiline ? 6 : 1}
                                                type={comment.multiline ? 'textarea' : 'text'}
                                            />
                                        </Label>
                                    </Col>
                                );
                        }
                    })}

                </Row >
            </Col>
            <Col md={2}>
                <Row>
                    <Col className="notesFormTypeControls text-right">
                        <Button
                            key={'submit_' + row.linkedID}
                            color="success"
                            value={row.linkedID}
                            onClick={handleEditSubmit}
                            disabled={
                                loading ||
                                !unsavedChanges ||
                                isFormBlank(editCategoryCommentsArray) ||
                                editCategoryCommentsArray.filter(item => item.error).length > 0
                            }
                            title="Submit"
                        >
                            <FontAwesomeIcon icon={loading ? faSpinner : faCheck} />
                        </Button>

                        <ConfirmButton
                            className="mx-2"
                            key={'delete_' + row.linkedID}
                            color="danger"
                            value={row.linkedID}
                            onClick={handleDelete}
                            title="Delete"
                        >
                            <FontAwesomeIcon
                                icon={loading && editID === row.linkedID ? faSpinner : faTrashAlt}
                            />
                        </ConfirmButton>

                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default ContactsDemographics2;
